<h2 mat-dialog-title>Grant Global Permissions</h2>

<mat-dialog-content>
    <mat-form-field appearance="fill" style="width:100%; margin-top:0.5rem;">
        <mat-label>Search user by name or email</mat-label>
        <input matInput [(ngModel)]="globalUserSearch" (ngModelChange)="searchUsers()"
            placeholder="e.g. John, john@example.com" />
    </mat-form-field>

    <div *ngIf="searchResults.length > 0" style="margin-bottom: 0.75rem;">
        <div class="assign-panel__perms-label">Select user</div>
        <table class="perm-grid ticket-table" style="margin-top: 0.5rem;">
            <tbody>
                <tr *ngFor="let u of searchResults" class="perm-grid__row" style="cursor:pointer;" [style.background]="
                selectedUserId === u.usr_id ? 'rgba(99,102,241,0.08)' : ''
              " (click)="selectedUserId = u.usr_id">
                    <td class="perm-grid__user-cell">
                        <div class="perm-grid__user-info">
                            <div class="avatar">
                                {{ u.usr_name.charAt(0).toUpperCase() }}
                            </div>
                            <div class="perm-grid__user-details">
                                <span class="perm-grid__user-name">{{ u.usr_name }}</span>
                                <span class="perm-grid__user-mail">{{ u.usr_mail }}</span>
                            </div>
                            <mat-icon *ngIf="selectedUserId === u.usr_id"
                                style="margin-left:auto; color:#6366f1;">check_circle</mat-icon>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="assign-panel__perms-label" style="margin-top:0.75rem;">
        Permissions to grant
    </div>
    <div class="invite-perms-grid" style="margin-top: 0.5rem;">
        <div *ngFor="let perm of data.globalPermissions" class="perm-chip"
            [class.perm-chip--selected]="selectedPermIds.has(perm.id)" (click)="
            selectedPermIds.has(perm.id)
              ? selectedPermIds.delete(perm.id)
              : selectedPermIds.add(perm.id)
          ">
            <mat-icon class="perm-chip__icon">
                {{
                selectedPermIds.has(perm.id)
                ? 'check_circle'
                : 'radio_button_unchecked'
                }}
            </mat-icon>
            {{ perm.mpm_type.replace('.', ' ') }}
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" [disabled]="!selectedUserId || selectedPermIds.size === 0"
        (click)="confirm()">
        <mat-icon>check</mat-icon> Grant Permissions
    </button>
</mat-dialog-actions>